<template>
  <div
    class="flex flex-col"
    :class="{ 'self-center text-center': align === 'center' }"
  >
    <h1 class="punchline">
      {{ title }}
    </h1>

    <div ref="subtitle" class="mt-8">
      <RichText
        v-if="subtitle"
        class="heading-3 md:max-w-[736px]"
        :class="{ 'line-clamp-3': clampLines }"
        :rich-text="subtitle"
        style-variant="none"
      />
    </div>

    <div v-if="clampLines" class="min-h-[36px]">
      <ClientOnly>
        <RevLink
          v-if="longSubtitle"
          class="text-action-default-low heading-3 mt-8"
          data-test="content-hub-hero-show-more"
          @click="clampLines = false"
        >
          {{ i18n(translations.readMoreIntro) }}
        </RevLink>
      </ClientOnly>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, useTemplateRef } from 'vue'

import type { BasePageContentAPI } from '@backmarket/http-api/src/api-specs-content/models/base-page-content'
import type { RichText as RichTextType } from '@backmarket/http-api/src/api-specs-content/models/rich-text'
import RichText from '@backmarket/nuxt-layer-cms/RichText.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import translations from './ContentHubHeroSection.translations'

type ContentHubHeroSectionProps = {
  title: string
  subtitle?: RichTextType
  align?: BasePageContentAPI['align']
}

withDefaults(defineProps<ContentHubHeroSectionProps>(), {
  subtitle: undefined,
  align: 'left',
})

const i18n = useI18n()

const clampLines = ref(true)
const longSubtitle = ref(false)
const subtitleRef = useTemplateRef<HTMLDivElement | null>('subtitle')

onMounted(() => {
  if (!subtitleRef.value) return

  const subtitleTruncatedHeight = subtitleRef.value.clientHeight
  const subtitleTotalHeight = subtitleRef.value.firstElementChild?.scrollHeight

  if (subtitleTotalHeight) {
    longSubtitle.value = subtitleTotalHeight > subtitleTruncatedHeight
  }
})
</script>
